import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from '@dreamtree-org/twreact-ui';
import RequireAuth from '@rbac/RequireAuth';
import { RequirePermission } from '@rbac/Can';
import DefaultLayout from '@layouts/DefaultLayout';
import { buildRoutes } from '@/routes';
import { useModuleRegistry } from '@/modules';
import Login from '@pages/Login';
import Join from '@pages/Join';
import Unauthorized from '@pages/Unauthorized';
import NotFound from '@pages/NotFound';
import AppearanceFrame from '@/merchant/pages/AppearanceFrame';
import UploadLink from '@/merchant/pages/UploadLink';

/** Merchant back office — mounted under the /admin basename on the merchant's own domain. */
export default function App({ store }) {
  const { modules, ready } = useModuleRegistry();
  const routes = buildRoutes(modules, { store });
  return (
    <ToastProvider>
      <Routes>
        {/* public */}
        <Route path="/login" element={<Login store={store} />} />
        <Route path="/join" element={<Join store={store} />} />
        {/* An assistant's upload link (MERCH-78): /admin/upload#<token>, the link is the credential. */}
        <Route path="/upload" element={<UploadLink store={store} />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* protected */}
        <Route element={<RequireAuth />}>
          {/* The Appearance editor's preview iframe (D51): the draft page alone, no shell. */}
          <Route path="/appearance/frame" element={<RequirePermission module="store" action="appearance"><AppearanceFrame /></RequirePermission>} />
          <Route element={<DefaultLayout store={store} />}>
            {routes.map((r) => (
              <Route
                key={r.path}
                path={r.path}
                element={<RequirePermission module={r.module} action={r.action}>{r.element}</RequirePermission>}
              />
            ))}
          </Route>
        </Route>

        <Route path="/404" element={<NotFound />} />
        {/* Until the live registry is in, a capability screen (/supply) is not routed yet: wait, don't 404. */}
        <Route path="*" element={ready ? <Navigate to="/404" replace /> : null} />
      </Routes>
    </ToastProvider>
  );
}
